import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const Payslips3DIcon = (t0)=>{
    const $ = c(7);
    const { width, height, color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter0_i_3982_59695)",
            children: /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.8975 9.80554C31.3332 9.62218 30.5732 9.59997 28.1996 9.59997H14.9996C13.2898 9.59997 12.1156 9.60137 11.2054 9.67574C10.3162 9.74839 9.83854 9.88161 9.49285 10.0577C8.70257 10.4604 8.06005 11.1029 7.65738 11.8932C7.51012 12.1822 7.39286 12.5635 7.31591 13.2004C7.47489 13.1999 7.64378 13.1999 7.82361 13.1999H32.8796C33.5501 13.1999 34.1648 13.1999 34.7309 13.2035C34.7003 12.9095 34.6565 12.6945 34.594 12.5021C34.1786 11.2235 33.1761 10.221 31.8975 9.80554ZM7.19961 30.4799L7.19961 24V17.4L7.19961 17.368C7.19962 17.154 7.19973 16.9679 7.20066 16.801C7.38199 16.7999 7.58596 16.7999 7.82361 16.7999H32.8796C34.9552 16.7999 36.2954 16.8027 37.3154 16.886C38.2934 16.9659 38.656 17.1016 38.834 17.1923C39.5114 17.5374 40.0621 18.0882 40.4072 18.7655C40.4979 18.9435 40.6336 19.3061 40.7135 20.2841C40.7968 21.3041 40.7996 22.6443 40.7996 24.7199V30.4799C40.7996 32.5555 40.7968 33.8957 40.7135 34.9157C40.6336 35.8937 40.4979 36.2563 40.4072 36.4343C40.0621 37.1117 39.5114 37.6624 38.834 38.0075C38.656 38.0982 38.2934 38.2339 37.3154 38.3138C36.2954 38.3971 34.9552 38.3999 32.8796 38.3999H15.1196C13.044 38.3999 11.7038 38.3971 10.6838 38.3138C9.70583 38.2339 9.34324 38.0982 9.16524 38.0075C8.48786 37.6624 7.93713 37.1117 7.59199 36.4343C7.50129 36.2563 7.36565 35.8937 7.28575 34.9157C7.20241 33.8957 7.19961 32.5555 7.19961 30.4799ZM3.59961 17.3246V17.4239V24V30.4799C3.59961 34.5123 3.59961 36.5285 4.38436 38.0686C5.07465 39.4234 6.17611 40.5249 7.53088 41.2151C9.07104 41.9999 11.0872 41.9999 15.1196 41.9999H32.8796C36.912 41.9999 38.9282 41.9999 40.4683 41.2151C41.8231 40.5249 42.9246 39.4234 43.6149 38.0686C44.3996 36.5285 44.3996 34.5123 44.3996 30.4799V24.7199C44.3996 20.6875 44.3996 18.6713 43.6149 17.1312C42.9246 15.7764 41.8231 14.6749 40.4683 13.9847C39.8668 13.6782 39.1927 13.4914 38.3543 13.3776C38.3071 12.6335 38.2113 11.9852 38.0179 11.3896C37.2463 9.01503 35.3846 7.15329 33.0099 6.38173C31.8291 5.99807 30.4406 5.99882 28.5106 5.99986L28.1996 5.99997L14.9242 5.99997C13.3081 5.99995 11.9864 5.99993 10.9122 6.0877C9.80042 6.17854 8.79626 6.3723 7.85849 6.85012C6.39082 7.59794 5.19757 8.79118 4.44976 10.2588C3.97194 11.1966 3.77817 12.2008 3.68733 13.3126C3.59957 14.3868 3.59959 15.7084 3.59961 17.3245V17.3246ZM31.7996 25.2001C30.8055 25.2001 29.9996 26.0059 29.9996 27C29.9996 27.9942 30.8055 28.8 31.7996 28.8H34.1996C35.1937 28.8 35.9996 27.9942 35.9996 27C35.9996 26.0059 35.1937 25.2001 34.1996 25.2001H31.7996Z",
                fill: color
            })
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("defs", {
            children: /*#__PURE__*/ jsxs("filter", {
                id: "filter0_i_3982_59695",
                x: "2.59961",
                y: "5.99976",
                width: "41.8008",
                height: "37.0002",
                filterUnits: "userSpaceOnUse",
                colorInterpolationFilters: "sRGB",
                children: [
                    /*#__PURE__*/ jsx("feFlood", {
                        floodOpacity: "0",
                        result: "BackgroundImageFix"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in: "SourceGraphic",
                        in2: "BackgroundImageFix",
                        result: "shape"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        in: "SourceAlpha",
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                        result: "hardAlpha"
                    }),
                    /*#__PURE__*/ jsx("feOffset", {
                        dx: "-1",
                        dy: "1"
                    }),
                    /*#__PURE__*/ jsx("feGaussianBlur", {
                        stdDeviation: "0.5"
                    }),
                    /*#__PURE__*/ jsx("feComposite", {
                        in2: "hardAlpha",
                        operator: "arithmetic",
                        k2: "-1",
                        k3: "1"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        type: "matrix",
                        values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in2: "shape",
                        result: "effect1_innerShadow_3982_59695"
                    })
                ]
            })
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== height || $[4] !== t1 || $[5] !== width) {
        t3 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2
            ]
        });
        $[3] = height;
        $[4] = t1;
        $[5] = width;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
export { Payslips3DIcon };
